module.exports = __webpack_public_path__ + "img/ai-icon.a52b865e.svg";